export const authors = [
  {
    id: 1,
    name: "John Kamau",
    photo: "/images/authors/john-kamau.jpg",
    title: "Senior Trade Finance Specialist",
    bio: "John has over 15 years of experience in international trade finance, specializing in Letters of Credit and bank guarantees for African markets.",
    credentials: "Certified Trade Finance Professional (CTFP)",
    linkedin: "https://linkedin.com/in/johnkamau",
    email: "j.kamau@trinityfinancing.com"
  },
  {
    id: 2,
    name: "Sarah Ochieng",
    photo: "/images/authors/sarah-ochieng.jpg",
    title: "LPO Financing Expert",
    bio: "Sarah specializes in helping manufacturing and distribution businesses scale through strategic LPO financing solutions.",
    credentials: "MBA, Finance",
    linkedin: "https://linkedin.com/in/sarahochieng",
    email: "s.ochieng@trinityfinancing.com"
  }
];

export const getAuthorById = (id) => authors.find(author => author.id === id);